export abstract class BaseEnum extends Object {
    readonly id: string;
    readonly descricao: string;
    readonly extras: any;

    constructor(id: string, descricao: string, extras?: any) {
        super();
        this.id = id;
        this.descricao = descricao;
        if (extras) {
            this.extras = extras;
        }
    }

    toString(): string {
        return this.id;
    }

    valueOf(): string {
        return this.id;
    }
}

/**
 * Cria uma nova classe base para uma "Enum". Assim os atributos estáticos não serão compartilhados.
 */
export function makeEnumClass() {
    return class EnumValue extends BaseEnum {
        static readonly all: EnumValue[] = [];

        static add(id: string, descricao: string, extras?: any): EnumValue {
            const value = new this(id, descricao, extras);
            this.all.push(value);
            return value;
        }

        static fromId(id: string): EnumValue {
            for (const value of this.all) {
                if (value.id == id) {
                    return value;
                }
            }
            return null;
        }

        static fromDesc(descricao: string): EnumValue {
            for (const value of this.all) {
                if (value.descricao == descricao) {
                    return value;
                }
            }
            return null;
        }
    };
}

export function toEnum(itens: { id: string; descricao: string; extras?: any }[]) {
    const newEnum = makeEnumClass();
    for (const item of itens) {
        if (item.extras) {
            newEnum.add(item.id, item.descricao);
        } else {
            newEnum.add(item.id, item.descricao, item.extras);
        }
    }
    return newEnum;
}
